import React from "react";
import Breadcrumbs from '../Components/banner/New-banner';
import ProductCard from '../Components/Product_Detail/productcart';
import ProductDescription from '../Components/description/description';
// import RelatedProducts from '../Components/related/related';
// import Related from "../Components/related/Relatedwork";
import RelatedProductsmy from '../Components/related/Final-related';
import Copyright from '../Components/Copyrights/Copyright';
import Topbar from '../Components/Topbar/Topbar';
import MiddleBar from '../Components/MiddleBar/MiddleBar';
import Navbar from '../Components/Navbar/nav';
import Footer from '../Components/Footer/Footer';
import Newsletter from '../Components/NewsLetter/Newletter';
// import { useParams } from 'react-router-dom';

function Pages(){
  
  // const [searchParams] = useSearchParams();
  // const _id = searchParams.get('_id');
  // const { id } = useParams();
  

  return(

    <div>
     <Topbar/>
     <MiddleBar/>
     <Navbar/>
     <Breadcrumbs/>
     <ProductCard />
     {/* <ProductDescription/> */}
     {/* <RelatedProductsmy/> */}
     {/* <Related/> */}
    {/* <RelatedProducts/> */}
     <Newsletter/>
     <Footer/>
     <Copyright/>
   
     
   
    
      

     
    
       
    </div>

  );

}
export default Pages;
